import { styled } from '@material-ui/core';
import { SRoundedContainer } from '@setvi/shared/components';

export const TextAreaFieldCard = styled(SRoundedContainer)({
  width: '100%',
  padding: '12px 16px',
  boxSizing: 'border-box'
});
